import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const addTicketTagById = createAsyncThunk(
  'ticket/addTicketTagById',
  async ({ ticketId, tags }, { rejectWithValue, getState }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    const business_id = loginToken?.response?.user?.business_id;
    try {
      const response = await axios.patch(
        `${ROOT_URL}/ticket/${ticketId}/${business_id}/tags/add`,
        { tags },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json',
          },
        }
      );
      return { ticketId, tags, ...response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addTicketTagByIdSlice = createSlice({
  name: 'addTicketTagById',
  initialState: {
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addTicketTagById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addTicketTagById.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(addTicketTagById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export default addTicketTagByIdSlice.reducer;